import { WorkflowBoard } from "../dtos";

/**
 * §Case-hold: the one sentence the CRM says about a held application — header pill tooltip and the
 * above-the-tabs banner share it so the copy cannot drift. "On hold since 6/9/2026, 1:05 PM by Islam —
 * Client travelling", dropping the parts that are absent.
 */
export const holdSummary = (hold: NonNullable<WorkflowBoard["onHold"]>): string => {
  const since = new Date(hold.at).toLocaleString();
  const by = hold.by?.trim() ? ` by ${hold.by.trim()}` : "";
  const reason = hold.reason?.trim() ? ` — ${hold.reason.trim()}` : "";
  return `On hold since ${since}${by}${reason}`;
};
